import blocknativeLogo from './icons/logo192.png'
import blocknativeIcon from './icons/logo192.png'

import { init } from '@web3-onboard/react'
import injectedModule from '@web3-onboard/injected-wallets'
import walletConnectModule from '@web3-onboard/walletconnect'
import coinbaseModule from '@web3-onboard/coinbase'


// Replace with your DApp's Infura ID
const INFURA_ID = `${process.env.REACT_APP_INFURA_KEY}`;

const injected = injectedModule()
const coinbase = coinbaseModule()
const walletConnect = walletConnectModule()

export const initWeb3Onboard = init({
  wallets: [
    injected,
    coinbase,
    walletConnect,
  ],
  chains: [
    {
      id: '0x89',
      token: 'MATIC',
      label: 'Polygon',
      rpcUrl: 'https://matic-mainnet.chainstacklabs.com',
    }
  ],
  appMetadata: {
    name: 'KEiiNO',
    icon: blocknativeIcon,
    logo: blocknativeLogo,
    description: 'KEiiNO - NFT Launch',
    recommendedInjectedWallets: [
      { name: 'Coinbase', url: 'https://wallet.coinbase.com/' },
      { name: 'MetaMask', url: 'https://metamask.io' }
    ],

  },
  accountCenter: {
    desktop: {
      position: 'topRight',
      enabled: true,
      minimal: true
    },
    mobile: {
      position: 'bottomRight',
    }
  },
  // example customizing copy
  i18n: {
    en: {
     
     
    }
  }
 
})
